(section_name=>{
    async function runIf(condition, callback, interval = 250, wait = 200) {
        while (wait--) {
            if (condition()) return callback();
            await new Promise(r => setTimeout(r, interval));
        }
    }

    runIf(() => document.querySelector('.acc-st-product-101_02_result_compare_card_box_section')
    && typeof Swiper === 'function', () => {
        const swiper = new Swiper('.acc-st-product-101_02_result_compare_container .acc-st-product-101_02_result_compare_card_box_section', {
            slidesPerView: 'auto',
            spaceBetween: 0,
            breakpoints: {
                768: {
                    slidesPerView: 'auto'
                }
            },
            pagination: {
                el: '.acc-st-product-101_02_result_compare_card_box_swiper-pagination',
                clickable: true,
            }
        }); 
    });
})("acc-st-landingpage-101_02");
